import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPOsWithFilters } from './store/slice';
import PomastersTopHead from './pomasters-top-head';
import PomastersContent from './pomasters-content';
import { selectPOFilterVisible, selectTileView } from './store/selectors';
import POModals from './pomasters-modals';

const POView = () => {
  const dispatch = useDispatch();
  const filterVisible = useSelector(selectPOFilterVisible);
  const tileView = useSelector(selectTileView);

  useEffect(() => {
    dispatch(fetchPOsWithFilters());
  }, [dispatch]);

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header transfer">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>PO Receiving</h4>
            </div>
          </div>
          <PomastersTopHead />
        </div>
        <PomastersContent filterVisible={filterVisible} tileView={tileView} />
        <POModals />
      </div>
    </div>
  );
};

export default POView;
